import { useBreadcrumbStore } from "@lib/stores/breadcrumbStore";
import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router";

const SECTION_BY_PREFIX: { prefix: string; label: string; href: string }[] = [
  { prefix: "/campaigns", label: "Campaigns", href: "/campaigns" },
  { prefix: "/clients", label: "Clients", href: "/clients" },
  { prefix: "/candidates", label: "Candidates", href: "/candidates" },
  { prefix: "/talent-pools", label: "Talent Pools", href: "/talent-pools" },
  { prefix: "/outreach", label: "Outreach", href: "/outreach" },
  { prefix: "/settings", label: "Settings", href: "/settings" },
];

function sectionFor(pathname: string) {
  return SECTION_BY_PREFIX.find(
    (s) => pathname === s.prefix || pathname.startsWith(`${s.prefix}/`),
  );
}

export function Breadcrumb() {
  const { pathname } = useLocation();
  const tail = useBreadcrumbStore((s) => s.tail);

  if (pathname === "/") {
    return <span className="text-sm font-medium text-text-primary">Dashboard</span>;
  }

  const section = sectionFor(pathname);
  if (!section) return null;

  const isDetail = pathname !== section.prefix;

  return (
    <div className="flex items-center gap-1 text-sm">
      {isDetail ? (
        <Link to={section.href} className="text-text-muted hover:text-text-secondary">
          {section.label}
        </Link>
      ) : (
        <span className="font-medium text-text-primary">{section.label}</span>
      )}
      {isDetail && (
        <>
          <ChevronRight size={14} className="text-text-faint" aria-hidden="true" />
          <span className="truncate font-medium text-text-primary">{tail ?? "…"}</span>
        </>
      )}
    </div>
  );
}
